import Mastermind from './Mastermind';

export default function App() {
  return <Mastermind />;
}
